// ------- plugin import -------- //
import React,{useState, useRef, useEffect } from 'react'
import { Modal } from 'antd';
import axios from 'axios'
import { toast } from 'react-toastify';
import Inputmask from 'inputmask';
// ---------- component import --------- //
import ValidationMessage from '../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';
import BizInfoSkeleton from './BizInfoSkeleton';
import BillingInfoDetails from './BillingInfoDetails';

const BillingInfo = (props) => {
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    // ------- define all state here --------- //
    const [addCreditModalIsOpen, setAddCreditModalIsOpen] = useState(false);
    const [isPayNow, setIsPayNow] = useState(false);
    const [paymentMethodForm, setPaymentMethodForm] = useState({
        available_amount: "0",
        credit_amount: "",
        name_on_card: "",
        card_number: "",
        validity: "",
        cvv: "",
        sass_id: localStorage.getItem('sass_id'),
        user_name : loginUserType === "SA"?localStorage.getItem('system_username'):''
    });
    const [paymentMethodFormError, setPaymentMethodFormError] = useState({});
    const [businessInfo, setBusinessInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [saveButtonLoader, setSaveButtonLoader] = useState(false);


    const validateField = (name, value) => {
        let error = "";
        if (name === "credit_amount") {
            if (!value || value.trim() === "") {
                error = "Credit amount is required";
            }
            else if((Number(value) < 250)){
                error = "Minimum credit amount is 250";
            }
        }
        if (name === "name_on_card") {
            if (!value || value.trim() === "") {
                error = "Name on card is required";
            } 
        }
        if (name === "card_number") {
            if (!value || value.trim() === "") {
                error = "Card number is required";
            } 
        }
        if (name === "validity") {
            if (!value || value.trim() === "") {
                error = "Validity is required";
            }
            else if(!/^\d{2}\/\d{4}$/.test(value)){
                error = "Enter validity in MM/YYYY format";
            }
            else{
                const [month, year] = value.split('/').map(Number);
                if (month < 1 || month > 12) {
                    error = "Month must be between 01 and 12";
                } else if (year < 2025 ) {
                    error = "Enter a valid year";
                }
            }
        }
        if (name === "cvv") {
            if (!value || value.trim() === "") {
                error = "CVV is required";
            } 
        }
        return error; 
    }

    const inputOnChangeHandler = (selectedOption, actionMeta) => {
        // ------ manage input ------ //
        if(selectedOption?.target){
            const { name, value, } = selectedOption.target;
            let fieldValue = value;
            if(name === 'credit_amount'){
                if(isPayNow){
                    return
                }
                fieldValue = value.replace(/[^0-9.]/g, '');
            }
            if(name === 'card_number'){
                fieldValue = value.replace(/[^0-9]/g, '');
            }
            if(name === 'cvv'){
                fieldValue = value.replace(/[^0-9]/g, '').slice(0, 4);
            }
            const fieldError = validateField(name, fieldValue);
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setPaymentMethodForm((prevData) => ({
                ...prevData,
                [name]: fieldValue,
            }));
        }
        // ------ manage select field ------ //
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setPaymentMethodForm((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
    }
    const payNowOnClickHandler = () => {
        let hasError = false;
        const newErrors = {};
        if (!paymentMethodForm.credit_amount) {
            newErrors.credit_amount = 'Credit amount is required';
            hasError = true;
        }
        else if (Number(paymentMethodForm.credit_amount) < 250) {
            newErrors.credit_amount = 'Minimum credit amount is 250';
            hasError = true;
        }
        if (hasError) {
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                ...newErrors
            }));
            return;
        }
        setPaymentMethodFormError({});
        setIsPayNow(true);
    }
    const onCloseHandler = () => {
        setPaymentMethodForm({
            credit_amount: "",
            name_on_card: "",
            card_number: "",
            validity: "",
            cvv: ""
        })
        setPaymentMethodFormError({})
    }
    const paymentMethodSaveHandler = async () => {
        
        const newErrors = { ...paymentMethodFormError };
        for (const key in paymentMethodForm) {
            const fieldError = validateField(key, paymentMethodForm[key]);
            if (!newErrors[key]) {
                newErrors[key] = fieldError;
            }
        }
        setPaymentMethodFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setSaveButtonLoader(true)
            // ---- api call ---- //
            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            var api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            await axios.post(`${api_base_url}admin/add-credit`, paymentMethodForm, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    toast.success(res.data.message);
                    onCloseHandler();
                    setAddCreditModalIsOpen(false)
                    setIsPayNow(false)
                    getBusinessInfo();
                    props.creditAdded(true)
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
                setSaveButtonLoader(false)
            })
            .catch((error) => {
                console.error(error);
                setSaveButtonLoader(false)
            })
        }
    }
    const inputRef = useRef(null);
    useEffect(() => {
        if(inputRef.current){
            Inputmask({ mask: '99/9999'}).mask(inputRef.current);
        }
    },[isPayNow]);

    // ----------- get business info --------- //
    const getBusinessInfo = async () => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/get-business-info`, {sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const bizInfoData = res.data.data.data[0];
                setBusinessInfo(bizInfoData);
                setIsLoading(false);
                setPaymentMethodForm((prevData) => ({
                    ...prevData,
                    'available_amount': bizInfoData.available_amount
                }));
                if(res.data.data.last_credit_amount.length > 0){
                    setBusinessInfo((prevData) => ({
                        ...prevData,
                        'last_credit_amount': res.data.data.last_credit_amount[0].amount,
                        'last_credit_on': res.data.data.last_credit_amount[0].last_payment_on
                    }))
                }
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        getBusinessInfo()
    },[]);

    return (
        <>
            {
                isLoading ? 
                <BizInfoSkeleton /> : 
                <BillingInfoDetails 
                    setAddCreditModalIsOpen={(param)=> setAddCreditModalIsOpen(param)}
                    businessInfo={businessInfo}
                />
            }
            <Modal
                open={addCreditModalIsOpen}
                title={null}
                footer={null}
            >
                <div className='row overflow-y-auto'>
                    <div className='col-md-12'>
                        <div className="text-center mb-5">
                            <h1 className="text-gray-800 mb-2 fs-2x">
                                Add credit
                            </h1>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                <span className="required">Add Credit</span>
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    INR
                                </span>
                                <input 
                                    type="text" 
                                    className="form-control form-control-solid" 
                                    placeholder="Add credit amount" 
                                    name="credit_amount"
                                    onChange={inputOnChangeHandler}
                                    disabled={isPayNow}
                                    value={paymentMethodForm.credit_amount}
                                    min="250"
                                />
                            </div>
                            {
                                paymentMethodFormError.credit_amount && 
                                <ValidationMessage 
                                    className='text-danger mt-2 lh-sm' 
                                    message ={paymentMethodFormError.credit_amount}
                                />
                            }
						</div>
                        <div className='text-end'>
                            {
                                !isPayNow && (
                                    <>
                                        <button 
                                            className="btn btn-dark me-2"
                                            onClick={() => {
                                                setAddCreditModalIsOpen(false);
                                                onCloseHandler()
                                            }}
                                        >
                                            Close
                                        </button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={payNowOnClickHandler}
                                            disabled={isPayNow}
                                        >
                                            Pay now
                                        </button>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    {
                        isPayNow &&
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">Name On Card</span>
                                        </label>
                                        <input
                                            type="text" 
                                            className="form-control form-control-solid" 
                                            placeholder="Name on card"
                                            name="name_on_card"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.name_on_card}
                                        />
                                        {
                                            paymentMethodFormError.name_on_card && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.name_on_card}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                Card number
                                            </span>
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-solid"
                                            placeholder="Card number"
                                            name="card_number"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.card_number}
                                        />
                                        {
                                            paymentMethodFormError.card_number &&
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.card_number}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-8'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                Validity
                                            </span>
                                        </label>
                                        <input 
                                            type="text" 
                                            ref={inputRef} 
                                            className="form-control form-control-solid" 
                                            placeholder="MM/YYYY"
                                            name="validity"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.validity}
                                        />
                                        {
                                            paymentMethodFormError.validity && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.validity}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                CVV
                                            </span>
                                        </label>
                                        <input
                                            type="text" 
                                            className="form-control form-control-solid" 
                                            placeholder="CVV"
                                            name="cvv"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.cvv}
                                        />
                                        {
                                            paymentMethodFormError.cvv && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.cvv}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12 text-end'>
                                    <button 
                                        className="btn btn-dark me-3"
                                        onClick={() => {
                                            setAddCreditModalIsOpen(false);
                                            setIsPayNow(false);
                                            onCloseHandler()
                                        }}
                                    >
                                        Close
                                    </button>
                                    <button 
                                        className={`btn btn-primary ${saveButtonLoader && 'disabled'}`}
                                        onClick={paymentMethodSaveHandler}
                                    >
                                        {
                                            saveButtonLoader ? 
                                            <ButtonLoader btnHtml='Please wait...' className='me-2'/>
                                            :
                                            'Save'
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        </>
    )
}

export default BillingInfo